import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { Analytics } from '../config'
import { LO_STO } from '../lib/constants'
import loSto from '../config/loSto'

ReactGA.initialize(Analytics.trackingId, {
  debug: true,
  gaOptions: {
    // TODO: set version from release
    appVersion: '2.0.0'
  }
})

// Wraps a component with Google Analytics to register pageviews
// More info: https://github.com/react-ga/react-ga/issues/122
const withAnalytics = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    ReactGA.set({
      page,
      userId: loSto.get(LO_STO.USER_ID),
      ...options
    })
    ReactGA.pageview(page)
  }

  const HOC = class extends Component {
    componentDidMount () {
      const page = this.props.location.pathname
      trackPage(page)
    }

    componentWillReceiveProps (nextProps) {
      const currentPage = this.props.location.pathname
      const nextPage = nextProps.location.pathname

      if (currentPage !== nextPage) {
        trackPage(nextPage)
      }
    }

    render () {
      return <WrappedComponent {...this.props} />
    }
  }

  return HOC
}

export default withAnalytics
